
define('text!templates/notifications-menu.html',[],function () { return '<li class="item8 nav-item-notifications">\n    <a href="/profile.php?section=fields&id=<%=user.id%>&p=notifications" style="position:relative;">\n        Уведомления<span class="bubble" style="display: none;">0</span>\n    </a>\n</li>\n';});

